import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import VueLazyload from 'vue-lazyload'
import infiniteScroll from 'vue-infinite-scroll'
import VueCookie from 'vue-cookie'
import { userInfo } from './api'
import { Button, Pagination, Checkbox, Icon, Autocomplete, Loading, Message, Notification, Steps, Step, Table, TableColumn, Input, Dialog, Select, Option } from 'element-ui'
import { getStore, setStore, removeStore } from '/utils/storage'
import VueContentPlaceholders from 'vue-content-placeholders'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueContentPlaceholders)
Vue.use(Button)
Vue.use(Pagination)
Vue.use(Checkbox)
Vue.use(Icon)
Vue.use(Autocomplete)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
Vue.use(infiniteScroll)
Vue.use(VueCookie)
Vue.use(VueClipboard)
Vue.use(VueLazyload, {
  loading: '/static/images/load.gif'
})
Vue.config.productionTip = false
window.router = router
const whiteList = ['/home', '/goods', '/extend', '/login', '/register', '/findPwd', '/goodsDetails', '/extendDetails', '/search', '/refreshsearch', '/refreshgoods', '/header', '/footer'] // 不需要登陆的页面
router.beforeEach(function (to, from, next) {
  let params = {
    token: getStore('token')
  }

  userInfo(params).then(res => {
    if (res.state !== 1) { // 没登录
      removeStore('token')
      removeStore('userId')
      removeStore('factoryId')
      if (whiteList.indexOf(to.path) !== -1) { // 白名单
        next()
      } else {
        next('/login')
      }
    } else {
      setStore('token', res.token)
      setStore('userId', res.userInfo.userId)
      setStore('factoryId', res.userInfo.factoryId)
      store.commit('RECORD_USERINFO', {info: res.userInfo})
      if (to.path === '/login') { //  跳转到
        next({path: '/'})
      }
      next()
    }
  })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js